module.exports = __webpack_public_path__ + "static/media/Лесная Ночь.df7357f5.jpg";